import React, { useEffect, useMemo, useState } from 'react'
import { getServices } from './../api/routes';
import { Link } from 'react-router-dom';

export default function Services() {
  const [services, setServices] = useState([]);

  useEffect(() => {
    getServices((isOk, data) => {
      if (!isOk) return alert(data.message);
      setServices(data || []);
    })
  }, []);

  const isEmpty = useMemo(() => !services || services.length === 0, [services]);

  return (
    <div className="relative bg-white overflow-hidden pt-10 md:pt-24 pb-10" id="services">
      <div className="container mx-auto px-4">
        {/* Heading */}
        <section className="flex flex-col items-center">
          <span className="px-5 py-2 rounded-full text-xs font-extrabold bg-[#0ea5b7] text-white shadow-md">
            خدمات مرکز
          </span>

          <h2 className="mt-5 text-center text-2xl sm:text-3xl font-black text-slate-900 tracking-tight">
            خدمات تصویربرداری و تشخیصی
          </h2>

          <div className="mt-4 h-[3px] w-16 rounded-full bg-gradient-to-r from-[#06b6d4] via-[#22c55e] to-[#3b82f6]" />

          <p className="text-center text-sm sm:text-base mt-6 text-slate-600 max-w-2xl leading-7">
            خدماتی که برای سلامتی شما در این مرکز ارائه می‌شود؛ با تجهیزات به‌روز، دقت بالا و گزارش تخصصی.
          </p>
        </section>

        {/* Grid cards */}
        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-7">
          {services.map((item) => (
            <section
              key={item.serviceId}
              className="group rounded-[28px] overflow-hidden bg-white/70 backdrop-blur-xl border border-white/60
                          ring-1 ring-black/5
                         transition hover:-translate-y-1 hover:shadow-[0_30px_90px_rgba(2,132,199,0.18)]"
            >
              {/* image */}
              <div className="relative">
                {item.image ? (
                  <img
                    loading="lazy"
                    src={`data:image/jpeg;base64,${item.image}`}
                    alt={item.serviceTitle}
                    className="w-full h-[210px] object-cover"
                  />
                ) : (
                  <div className="w-full h-[210px] bg-slate-100" />
                )}

                {/* top gradient strip */}
                <div className="absolute inset-x-0 top-0 h-2 bg-gradient-to-r from-[#06b6d4] via-[#22c55e] to-[#3b82f6]" />

                {/* subtle hover glow */}
                <div className="pointer-events-none absolute -bottom-16 -left-16 h-44 w-44 rounded-full bg-[#9be9ff] blur-3xl opacity-0 group-hover:opacity-40 transition" />
              </div>

              {/* content */}
              <div className="p-5 flex flex-col min-h-[220px]">
                <h3 className="text-base sm:text-lg font-extrabold text-slate-900">
                  {item.serviceTitle}
                </h3>

                <p className="mt-3 text-sm sm:text-[15px] text-slate-600 leading-7 line-clamp-4">
                  {item.serviceShortText}
                </p>

                <div className="mt-auto pt-4 flex items-center justify-between">

                  <Link to={`/service/${item.serviceId}`}>
                    <button className="h-[42px] px-4 rounded-2xl font-extrabold text-white bg-gradient-to-r from-[#06b6d4] to-[#0284c7] shadow-md hover:shadow-lg transition">
                      ادامه مطلب
                    </button>
                  </Link>
                </div>
              </div>
            </section>
          ))}
        </div>

        {/* Empty state */}
        {isEmpty && (
          <div className="mt-12 text-center text-slate-600">
            فعلاً خدماتی ثبت نشده است.
          </div>
        )}
      </div>
    </div>
  )
}
